import { WithdrawalReportTable } from './WithdrawalReportTable';

export default WithdrawalReportTable;
